<script lang="ts">
  interface UploadFile extends File {
    onUpload?(sendbytes: number): void;
    onError?(message: string): void;
  }

  interface UploaderProps {
    /**
     * upload url
     */
    actionURL: string;
    /**
     * autoupload default true
     */
    autoupload?: boolean;
    onUpload?(file: any): void;
    access_token?: string;
  }
  interface _UploaderProps extends UploaderProps {
    el: Element;
  }

  export let props: UploaderProps;

  class Uploader {
    props: _UploaderProps;
    fileList: FileList;
    fileListContainer: Element;

    constructor(props: _UploaderProps) {
      this.props = props;
      this._init();
    }

    private _init() {
      const el = this.props.el;
      // el.setAttribute("class", "Uploader");

      el.addEventListener(
        "dragenter",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          el.classList.add("dragover");
        },
        false
      );

      el.addEventListener(
        "dragstart",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          el.classList.add("dragover");
        },
        false
      );

      el.addEventListener(
        "dragover",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          el.classList.add("dragover");
        },
        false
      );

      el.addEventListener(
        "dragleave",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          el.classList.remove("dragover");
        },
        false
      );

      el.addEventListener(
        "dragend",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          el.classList.remove("dragover");
        },
        false
      );

      el.addEventListener("drop", (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.fileList = ev.dataTransfer.files;
        this._renderFileList();
        el.classList.remove("dragover");

        if (this.props.autoupload) {
          let list = this.fileList;
          for (var i = 0; i < list.length; i++) {
            this.uploadFile(list.item(i));
          }
        }
      });

      let fileUpload = document.createElement("input");
      fileUpload.setAttribute("type", "file");
      fileUpload.setAttribute("style", "display:none");
      fileUpload.setAttribute("multiple", "true");

      fileUpload.addEventListener("change", (ev) => {
        this.fileList = fileUpload.files;
        this._renderFileList();
        if (this.props.autoupload) {
          let list = this.fileList;
          for (var i = 0; i < list.length; i++) {
            this.uploadFile(list.item(i));
          }
        }
      });

      this.props.el.appendChild(fileUpload);
      this.props.el.addEventListener("click", (ev) => {
        fileUpload.click();
      });
    }

    private _renderFileList() {
      let cntr = this._getFileListContainer();
      cntr.innerHTML = "";
      cntr.setAttribute("class", "FileList");
      for (var i = 0; i < this.fileList.length; i++) {
        cntr.appendChild(this._createFileItemContainer(this.fileList[i]));
      }
    }

    private _getFileListContainer(): Element {
      if (!this.fileListContainer) {
        this.fileListContainer = this._createDiv();
        this.props.el.appendChild(this.fileListContainer);
      }
      return this.fileListContainer;
    }

    private _createFileItemContainer(file: UploadFile): Element {
      let row = this._createDiv();
      row.setAttribute("class", "File");
      row.addEventListener("click", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
      });

      let fname = this._createDiv();
      fname.setAttribute("class", "Filename");
      fname.innerHTML = file.name;
      let fsize = this._createDiv();
      fsize.setAttribute("class", "Filesize");
      fsize.innerHTML = Uploader.bytesToSize(file.size);
      row.appendChild(fname);
      row.appendChild(fsize);

      file.onError = (msg: string) => {
        row.setAttribute("class", "File Error");
        row.setAttribute("title", msg);
      };

      file.onUpload = (size: number) => {
        if (size !== file.size) {
          fsize.innerHTML =
            '<span style="color:green" class="Loading">' +
            Uploader.bytesToSize(size) +
            "</span> / " +
            Uploader.bytesToSize(file.size);
        } else {
          fsize.innerHTML =
            '<b class="TotalSize">' + Uploader.bytesToSize(file.size) + "</b>";
          row.removeAttribute("title");
          if (props.onUpload) {
            props.onUpload(file);
          }
        }
      };

      row.addEventListener("click", (ev) => {
        this.uploadFile(file);
      });
      return row;
    }

    private _createDiv(): Element {
      return document.createElement("div");
    }

    public static bytesToSize(bytes: number) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "n/a";
      let x: number = Math.log(bytes) / Math.log(1024);
      const i = Math.floor(x);
      if (i === 0) return `${bytes} ${sizes[i]})`;
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
    }

    public uploadFile(file: UploadFile) {
      var xhr = new XMLHttpRequest();
     
      xhr.upload.addEventListener("progress", (ev) => {
        file.onUpload(ev.loaded);
      });
     
      xhr.addEventListener("load", (ev: any) => {
        if (ev.currentTarget.status) {
          file.onUpload(file.size);

          if (ev.currentTarget.status !== 200) {
            file.onError("Hopla! :-/ Da ist was kapput!");
          }
        }
      });
      xhr.addEventListener("error", (ev) => {
        file.onError("Hopla! Da ist was schiefgelaufen :-/");
      });
      xhr.addEventListener("abort", (ev) => {});
      xhr.open("POST", this.props.actionURL);

      if (props.access_token) {
        xhr.setRequestHeader("Authorization", "Bearer " + props.access_token);
      }

      var formdata = new FormData();
      formdata.append("uploadfile", file);

      xhr.send(formdata);
    }
  }

  const _init = (el) => {
    const upl = new Uploader({
      actionURL: props.actionURL,
      autoupload: props.autoupload || true,
      el: el,
    });
  };
</script>

<div class="Uploader" use:_init />
